import { render, staticRenderFns } from "./GroupCard.vue?vue&type=template&id=9312a16e&"
import script from "./GroupCard.vue?vue&type=script&lang=js&"
export * from "./GroupCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports